<script>
  import "./config/amplify.js"
  import Router from "svelte-spa-router"
  import InputId from "./InputId.svelte"
  import Attention from "./Attention.svelte"
  import Questionnaire from "./Questionnaire.svelte"
  import Test from "./Test.svelte"
  import AdminAuth from "./components/admin/AdminAuth.svelte"
  import AdminDashboard from "./components/admin/AdminDashboard.svelte"
  import { adminAuth } from "./stores/adminAuth.js"
  import { onMount } from "svelte"

  const routes = {
    "/": InputId,
    "/questionnaire": Questionnaire,
    "/attention": Attention,
    "/test": Test,
    // 管理者ルート
    "/admin": AdminAuth,
    "/admin/dashboard": AdminDashboard,
  }

  onMount(async () => {
    await adminAuth.init()
  })
</script>

<Router {routes} />
